export default __webpack_public_path__ + "static/media/incoming-message.ca702b28.mp3";